/* eslint-disable security/detect-object-injection */
/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useEffect, useRef, useState, useContext } from "react"
import TopHeader from "../../../components/TopHeader"
import { motion } from 'framer-motion'
import { Link } from "react-router-dom"
import ConfirmationPrompt from '../../../components/ConfirmationPrompt'
import AnimatedModel from '../../../components/Animation/AnimatedModel'
import moment from "moment"
import formatMobileNumber from '../../../CommonMethods/FormatMobileNumber';
import { useParams, useLocation, useNavigate, useSearchParams } from "react-router-dom"
import {useDispatch, useSelector } from 'react-redux'
import CustomOverLay from "../../../components/CustomOverLay"
import GlobalContext from "../../../components/Context/GloablContext"
import SearchEmptyScreen from "../../../components/SearchEmptyScreen"
import { convertEpochToDateFormat } from "../../../CommonMethods/convertEpochToDateFormat"
import { useExportPatientNotesMutation, useGetMonitorAssociatedToPatientListQuery, useGetProviderAssociatedToPatientListQuery, useSendProviderAlertMutation, useViewPatientDetailsQuery } from '../../../slices/patientSlice'
import ViewPatientDetails from "./Components/ViewPatientDetails"
import ViewAdministartiveDetails from "./Components/ViewAdministrativeNotes"
import ViewMedicalNoteDetails from "./Components/ViewMedicalNotes"
import ViewPatientMoniteringCondition from "./Components/viewPatientMoniteringCondition"
import ViewPatientDevices from "./Components/ViewPatientDevices"
import { dataService } from '../../../services/data.services'
import Loader from "../../../components/Loader"
import Toast from "../../../components/Toast"
import TextAreaWellness from "../../../components/TextAreaWellness"
import ProviderDropdown from "./DropdownproviderDetails"
import { handleEditMessageSent } from "../../../redux/systemConfigSlice"
import HelpGuideModal from "../../../components/HelpGuideModal"
import {useGetHelpGuideProviderQuery} from '../../../slices/patientSlice'
import { organizationusersList } from "../../../slices/apiSlice"

export default function ViewPatient() {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [sendAlert] = useSendProviderAlertMutation()
    const [initialLoader, setInitialLoader] = useState(true);
    const [searchParams, setSearchParams] = useSearchParams()
    const { isSideBar, setToastmessage,sendMessageToStartEditing,editSocket } = useContext(GlobalContext)
    const location = useLocation();
    const auth = useSelector(state => state.auth)
    const [emptyField, setEmptyField] = useState(false)
    const userType = sessionStorage.getItem('user_type');
    const [patientDetails, setViewPatientDetails] = useState("");
    const [notedetails, setViewNoteDetails] = useState("");
    const [profileDetails, setProfileDetails] = useState({});
    const [medicalNotes, setViewMedicalDetails] = useState("")
    const [exportNotes] = useExportPatientNotesMutation()
    const [exportLoading, setExportLoading] = useState(false)
    const [loading, setLoading] = useState(true)
    const [sendalertloading, setalertloading] = useState(false)
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [confirmation, setConfirmation] = useState(false)
    const [confirmationState, setConfirmationState] = useState(false)
    const [confirmationTablestate, setConfirmationTableState] = useState(false)
    const dateformat = useSelector(state => state.systemConfigData.globalVariables.date_format)
    const [patientTabName, setPatientTabName] = useState('patient')
    const [sendalertDetails, setsendalertDetails] = useState({
        "alert_message": "",
        "alert_priority": "",
        "recepient_details": [],
    })
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const [notesCount, setNotesCount]=useState('0')

    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideProviderQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)

    const { id } = useParams()
    // view patient api
    const { data, isFetching, status,refetch } = useViewPatientDetailsQuery(id, { refetchOnMountOrArgChange: true })
    // view monitoe
    const { data: monitorsList, isFetching: monitorsFetching, isLoading, status: monitorslistStatus } = useGetMonitorAssociatedToPatientListQuery(patientDetails?.patient_id, { refetchOnMountOrArgChange: true })
    const { data: providerList, isFetching: providerfetching, isLoading: providerloading, status: providerstatus } = useGetProviderAssociatedToPatientListQuery(patientDetails?.patient_id, { refetchOnMountOrArgChange: true })
    // Get the user_id from sessionStorage
    const user_id = sessionStorage.getItem('user_id');
    const matchingObject = monitorsList && monitorsList.data.find(obj => obj.monitorUserData.user_id === user_id);
    const outsideClickRef = useRef();

    const handleOnChangeUserDetails = (key, value) => {
        // Update the state with the new value
        setsendalertDetails(prevState => ({
            ...prevState,
            [key]: value
        }));
    };
    const obj = []
    // handle send alert
    const handleSendAlert = async () => {
        setalertloading(true);
        if (providerList?.data.length > 0) {
            providerList.data.map((item) => {
                if (sendalertDetails?.recepient_details?.includes(item.providerUserData.user_id)) {
                    obj.push(
                        { "recepient_id": item.providerUserData.user_id, "recepient_name": `${item.providerUserData.last_name} ${item.providerUserData.first_name}` }
                    )
                }
            })
        }
        let body =
        {
            "alert_priority": sendalertDetails.alert_priority,
            "alert_message": sendalertDetails.alert_message,
            "patient_id": patientDetails?.patient_id,
            "recepient_details": obj,
        }
        const response = await sendAlert(body)
        setalertloading(false);
        if (response.error) {
            setalertloading(false);
            setConfirmationState(false);
            setConfirmation(false) 
            setConfirmationTableState(false);
            if(response.error.data.message==='Unauthorized'){
                setToastErrorMessage('You are not authorized to send alert to this patient')
            }
            else{
                setToastErrorMessage(response.error.data.message);

            }
        }
        else{
            setToastmessage(response.data.message)
            setalertloading(false);
            setConfirmationState(false);
            setConfirmation(false) 
            setConfirmationTableState(true);
        }
        refetch()

    }

    const handleEditButtonClick = () =>{
        
        if(!messageSent){
            sendMessageToStartEditing(patientDetails?.patient_id)

            let message
            editSocket.onmessage = (event) =>{
                message = event.data
                console.log('Received message:',JSON.parse(message)?.success_status===true,JSON.parse(message)?.message==='Success');
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    navigate(`/manage-patients/edit-patient/${id}`, { state: { ...location.state, fromscreen: 'view' } })

                } else{
                        
                    dispatch(handleEditMessageSent(false))
                    {JSON.parse(message)?.adminId!==undefined && 
                        setToastErrorMessage(`A user with username ${decodeURIComponent(JSON.parse(message)?.adminId)} is already editing this patient`)
                    }
                }
            }    
        }
    }   

    useEffect(() => {
        if (data !== undefined) {
            setViewPatientDetails(data[0])
            const administrativeNotes = data[0]?.notes || []; // Ensure notes array exists
            const notes = administrativeNotes
                .filter(item => item.note_type === "administrative-note") // Filter out only administrative notes
                .map(item => ({
                    administrative_Notes: item.description || '',
                    first_name: item.first_name || '',
                    last_name: item.last_name || '',
                    user_type: item.user_type || '',
                    created_date: item.timestamp || '',
                    patient_id: item.patient_id || '',
                }));
            setViewNoteDetails(notes);
            const medicalNotes = data[0]?.notes || []; // Ensure notes array exists
            const medicalnote = medicalNotes
                .filter(item => item.note_type === "medical-note") // Filter out only administrative notes
                .map(item => ({
                    medical_Notes: item.description || '',
                    first_name: item.first_name || '',
                    last_name: item.last_name || '',
                    user_type: item.user_type || '',
                    patient_id: item.patient_id || '',
                    created_date: item.timestamp || '',
                }));

            setViewMedicalDetails(medicalnote);
        }
    }, [data])

    useEffect(() => {
        const isManageDashboard = location?.pathname?.includes('manage-dashboard');
    
        if (userType === 'monitor-user') {
            setQueryParamsorg(isManageDashboard ? 'type=monitor-dashboard-view-patient' : 'type=monitor-view-patient');
        } else {
            setQueryParamsorg(isManageDashboard ? 'type=provider-dashboard-view-patient' : 'type=provider-view-patient');
        }
    }, [userType, location]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

  

    const handleTabChange = (tabName) => {
        setPatientTabName(tabName)
    }

    //Administrative & Medical Notes Export
    async function handleExport(type) {
        let patientId = data[0].patient_id
        let noteType = type
        setExportLoading(true)

        let payload = { patientId, dateformat, noteType }
        const exportRes = await exportNotes(payload)
        setExportLoading(false)
        window.open(exportRes?.data?.presigned_url)

        if (exportRes?.error) {
            setToastErrorMessage("Something went wrong")
        }
        else {
            setToastmessage(exportRes?.data?.message)
        }
    }

    const handleFetchProfileDetails = async () => {
        setInitialLoader(true)
        const response = await dataService.getProviderMonitordetails();
        if (response.error === false) {
            setProfileDetails(response.data.userDetails)
            setInitialLoader(false)
        } else {
            setInitialLoader(false)
        }
    }
    // handle sendbutton
    function handleSendButton() {
        const hasEmptyFields = () => {
            let isFieldsEmpty = false
            if (
                sendalertDetails.recepient_details.length === 0 ||
                !sendalertDetails?.alert_priority ||
                sendalertDetails?.alert_message === ""
            ) {
                isFieldsEmpty = true;
            }
            return isFieldsEmpty;
        };
        if (hasEmptyFields()) {

            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        }
        setConfirmationState(true);
        setConfirmation(true);
    }


    useEffect(() => {
        handleFetchProfileDetails()
    }, [])

    const handleContinueButton = async () => {
        setLoading(true);
        setConfirmationTableState(false)
        setLoading(false);
        setEmptyField(false);
        setsendalertDetails(prevState => ({
            ...prevState,
            alert_priority: '',
            alert_message: '',
            recepient_details: []// Clear alert_priority while keeping other fields intact

        }));
    }


    const handleReadingTypeSelect = (user_id) => {
        setsendalertDetails((prev) => {
            // Check if the user_id is already in the array
            const isItemSelected = prev.recepient_details.includes(user_id);

            // Create a new array to hold the updated monitor_list
            let updatedMonitorList;

            if (isItemSelected) {
                // If the item is already selected, remove it
                updatedMonitorList = prev.recepient_details.filter(id => id !== user_id);
            } else {
                // If the item is not selected, add it
                updatedMonitorList = [...prev.recepient_details, user_id];
            }

            return {
                ...prev,
                recepient_details: updatedMonitorList
            };
        });
    }

    const handleOpenAlertModal = () => {
        let array = [];
        if (providerList?.data.length > 0) {
            providerList.data.map((item) => {
                if (item.providerUserData.send_alert === true) {
                    array.push(item.providerUserData.user_id)
                }
            })
        }
        setsendalertDetails(prevState => ({
            ...prevState,
            recepient_details: array
        }));
        setConfirmation(true)
    }
    const date = convertEpochToDateFormat(patientDetails?.created_at, dateformat)

    useEffect(()=>{
        if(Array.isArray(location.state)&&location?.state?.length===1&&(!location?.state?.[0]?.includes('@'))){
             handleTabChange(location?.state?.[0])
             navigate({
               state: {}
             });
        }
     },[location])

    useEffect(()=>{
        if(location.state==='vital_screen'){
         handleTabChange('monitoring_conditions')
        }else if(location?.state==='device_screen'){
         handleTabChange('device_details')
        }
     },[location])
    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Patients"} />
                {isFetching && status !== "fulfilled" ? <CustomOverLay Active text="Loading Patient Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> : status === "rejected" ? <SearchEmptyScreen text={"No data found"} /> : <>

                    <div className='bg-white rounded-lg py-[12px] px-[30px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='flex items-center mb-[22px]'>
                                    <Link to="/manage-patients" state={Array.isArray(location.state) ? '' : location.state}>
                                        <h1 className="text-sm font-normal text-[#52555D]">List of Patients</h1>
                                    </Link>
                                    <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                    <Link to={`/manage-patients/provider-list/${id}/${patientDetails?.patient_id}`} state={Array.isArray(location.state) ? '' : location.state}>
                                        <h1 className="text-sm font-normal text-[#52555D]">Vital Data</h1>
                                    </Link>
                                    <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                    <Link to="">
                                        <h1 className="text-sm font-normal text-[#008586]">View Patient</h1>
                                    </Link>
                                    <span   onClick={() => setHelpGuideModel(true)} className=' ml-auto cursor-pointer'>
                                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                    </span> 
                                </div>
                                <div className="flex items-center pb-3 pr-9">
                                    <Link to={`/manage-patients`} state={Array.isArray(location.state) ? '' : location.state} className='flex items-center min-w-max z-[99]'>
                                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                        <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                    </Link>
                                    <h1 className='text-xl font-normal text-[#000000] text-center w-full xl:-ml-[146px]'>
                                        View Patient
                                    </h1>
                                    {((patientTabName === "monitoring_conditions") && (matchingObject?.monitor_permission === 'monitor' || userType === 'provider')) &&
                                        <div className="xl:hidden block">
                                            <button
                                                onClick={()=>{handleEditButtonClick()}}
                                                type='button'
                                                data-testid={'edit-btn'} id={"edit"}
                                                className={`min-w-max px-4 py-2 border hover:bg-[#EDD7E1] border-[#972E4C] h-fit rounded-[16px] flex items-center ml-4`}>
                                                <span className='w-5'><img src="/images/edit_icon.svg" alt="icon" /></span>
                                                <span className='pl-2.5 text-lg font-normal text-[#972E4C]' data-testid="edit-btn" id="edit">Edit</span>
                                            </button>
                                        </div>
                                    }
                                </div>
                                <div>
                                    <div className="flex justify-between items-center pl-[30px] xl:pr-11 pr-10">
                                        <div className="flex items-center">
                                            <p className="text-xl font-semibold text-[#000000]">{patientDetails?.last_name} {patientDetails?.first_name} {patientDetails?.middle_name}</p>
                                            <p id='id' className="text-sm font-normal text-[#000000] px-2">{patientDetails?.patient_id}</p>
                                            {patientDetails?.status == 'inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> :
                                            <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                            }
                                        </div>

                                        <div className="flex items-center">
                                            {(patientTabName === "monitoring_conditions") &&
                                                <button type="button"
                                                    id={'activity-log'}

                                                    onClick={() => { dispatch(organizationusersList.util.resetApiState());                
                                                    navigate('/manage-patients/activity_history', { state: [patientDetails.user_name, true, id] }) }}
                                                    className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                                    rounded-[16px] bg-[#972E4C]  min-w-max focus:bg-[#863B50] disabled:bg-[#777C88] xl:mr-4 ml-2 `}
                                                >
                                                    View Change History
                                                </button>
                                            }
                                            {((userType === 'monitor-user')&& (matchingObject?.monitor_permission === 'monitor')) && <button type="button"
                                                id={'send_alert'}
                                                onClick={() =>{
                                                 handleOpenAlertModal()}}
                                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                                    rounded-[16px] bg-[#972E4C]  min-w-max focus:bg-[#863B50] disabled:bg-[#777C88] xl:mr-4 ml-2 `}
                                            >
                                                Send Provider Alert  </button>
                                            }
                                            {(patientTabName === "patient") &&
                                                <button type="button"
                                                    id={'contact-history'}
                                                    onClick={() => {dispatch(organizationusersList.util.resetApiState());                
                                                    navigate(`/manage-patients/view-patient/contact-history/${id}/${patientDetails.patient_id}`, { state: [patientDetails.patient_id, true, id] }) }}
                                                    className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                                    rounded-[16px] bg-[#972E4C]  min-w-max focus:bg-[#863B50] disabled:bg-[#777C88] xl:mr-4 ml-2 `}
                                                >
                                                    View Contact History
                                                </button>
                                            }
                                            {( (patientTabName==="device_details") && (userType === 'monitor-user')) &&
                                            <button type="button" id="welleness_check" data-testid="reading-history"
                                                onClick={()=>{  dispatch(organizationusersList.util.resetApiState()) ;               
                                                 navigate(`/manage-patients/view-patient/${patientDetails?._id}/vital-history/device/${patientDetails?.patient_id}`, { state: [patientDetails.patient_id, true, id] }) }}
                                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] 
                                        rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                            focus:bg-[#863B50] disabled:bg-[#777C88] ml-2 ${patientTabName==="administrative_notes" || patientTabName==="medical_notes" ? "xl:block hidden" : "block"}`}>
                                                Reading History
                                                </button>
                                            }

                                            {(patientTabName === "administrative_notes" && notesCount !== 0) &&
                                                <button id="icon-export" disabled={exportLoading} onClick={() => handleExport("administrative-note")} className="border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] disabled:cursor-not-allowed ml-4">
                                                    {exportLoading ?
                                                        <div className='flex justify-center items-center'>
                                                            <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-5 w-5 spin-animation"></div>
                                                        </div>
                                                        : <img src="/images/download-red.svg" alt="download-icon" />}
                                                </button>
                                            }
                                            {(patientTabName === "medical_notes" && notesCount !== 0) &&
                                                <button id="icon-export" disabled={exportLoading} onClick={() => handleExport("medical-note")} className="border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] disabled:cursor-not-allowed ml-4">
                                                    {exportLoading ?
                                                        <div className='flex justify-center items-center'>
                                                            <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-5 w-5 spin-animation"></div>
                                                        </div>
                                                        : <img src="/images/download-red.svg" alt="download-icon" />}
                                                </button>
                                            }

                                            {((patientTabName === "monitoring_conditions") && (matchingObject?.monitor_permission === 'monitor' || userType === 'provider')) &&
                                                <div className="xl:block hidden">
                                                    <button
                                                        onClick={()=>{handleEditButtonClick()}}
                                                        // onClick={() => { navigate(`/manage-patients/edit-patient/${id}`, { state: { ...location.state, fromscreen: 'view' } }) }}
                                                        id="edit" data-testid={'edit-btn'}
                                                        className={`min-w-max px-4 py-2 hover:bg-[#EDD7E1] border border-[#972E4C] h-fit rounded-[16px] flex items-center`}>
                                                        <span className='w-5'><img src="/images/edit_icon.svg" alt="icon" /></span>
                                                        <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className='mx-7 mt-4'>
                                        <div className='flex justify-between pb-2 overflow-x-auto overflow-y-visible scrollBar-hidden border-b border-[#E7CBD2] w-full mr-6'>
                                            <button onClick={() => { handleTabChange('patient') }} className={`px-2 pt-2.5 min-w-fit text-base font-semibold ${patientTabName === 'patient' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'patient' ? 'patient_tab' : ''}`}>
                                                Patient Details
                                            </button>
                                            <button id={'monitor_tab'} data-testid={'monitoring_conditions'} onClick={() => { handleTabChange('monitoring_conditions') }} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'monitoring_conditions' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'monitoring_conditions' ? 'patient_tab' : ''}`}>
                                                Monitoring Conditions
                                            </button>
                                            <button id={'device_details'} onClick={() => { handleTabChange('device_details') }} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'device_details' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'device_details' ? 'patient_tab' : ''}`}>
                                                Device Details
                                            </button>
                                            <button id={'administrative_notesTab'} onClick={() => { handleTabChange('administrative_notes') }} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'administrative_notes' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'administrative_notes' ? 'patient_tab' : ''}`}>
                                                Administrative Notes
                                            </button>
                                            <button id={'medical_notesTab'} onClick={() => { handleTabChange('medical_notes') }} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'medical_notes' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'medical_notes' ? 'patient_tab' : ''}`}>
                                                Medical Notes
                                            </button>
                                        </div>
                                    </div>
                                    {patientTabName === "patient" &&
                                        <ViewPatientDetails
                                            date={date}
                                            patientDetails={patientDetails}
                                        />}
                                    {patientTabName === "administrative_notes" && <ViewAdministartiveDetails
                                        date={date}
                                        notedetails={notedetails}
                                        patientDetails={patientDetails}
                                        setNotesCount={setNotesCount}

                                    />}
                                    {patientTabName === "medical_notes" && <ViewMedicalNoteDetails
                                        date={date}
                                        patientDetails={patientDetails}
                                        medicalNotes={medicalNotes}
                                        setNotesCount={setNotesCount}

                                    />}
                                    {patientTabName === 'monitoring_conditions' &&
                                        <ViewPatientMoniteringCondition
                                            date={date}
                                            patientDetails={patientDetails}
                                        />
                                    }
                                    {patientTabName === "device_details" && patientDetails?.patient_id &&<ViewPatientDevices
                                        patient_id={patientDetails?.patient_id}
                                    />}
                                    {(helpGuideModel && helpguidestatus==="fulfilled") &&
                                    <HelpGuideModal
                                        setHelpGuideModel={setHelpGuideModel}
                                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }

                                </div>
                            </div>

                        </motion.div>
                    </div>
                </>}
            </div>
            {/* send alert model */}
            {confirmation &&
                <AnimatedModel key="edit-model"
                    Children={
                        <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabIndex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{ display: "block" }}>
                            <div ref={outsideClickRef} data-te-modal-dialog-ref="" className="pointer-events-none relative flex min-h-[calc(100vh-1rem)] w-auto translate-y-[-50px] translate-x-[10px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[943px] m-auto max-w-[943px] pt-[80px]">
                                <div className="pointer-events-auto flex w-full flex-col rounded-[16px] border-none bg-white bg-clip-padding text-current shadow-lg outline-none min-w-[943px] mx-auto max-w-[943px] px-[24px] pt-[24px] pb-5 relative">
                                    <div className="flex justify-between pb-[16px] ">
                                        <h1 className='text-2xl font-normal text-[#000]'>Alert Message</h1>
                                        <img
                                            onClick={() => {
                                                setConfirmation(false);
                                                setEmptyField(false);
                                                setsendalertDetails(prevState => ({
                                                    ...prevState,
                                                    alert_priority: '',
                                                    alert_message: '',
                                                    recepient_details: []// Clear alert_priority while keeping other fields intact

                                                }));
                                            }} src='/images/close_icon.svg' className='cursor-pointer' />
                                    </div>

                                    <div className='  border border-[#C5C9DA] rounded-[8px] p-[24px] overflow-auto overflow-x-hidden scrollbar_grayw6 h-customh12'>
                                        <div className='w-[425px]  mb-[32px]'>
                                            <p className="text-[12px] leading-[16px] font-semibold text-[#000000] pb-[6px]">Recipient</p>

                                            <ProviderDropdown
                                                id={`monitor_name`}
                                                data_testid={""}
                                                placeholder={`${sendalertDetails.recepient_details.length === 0 ? "Select recepient" : `${sendalertDetails.recepient_details.length} selected`}`}
                                                disabled={false}
                                                options={providerList && providerList.data}
                                                handleReadingTypeSelect={handleReadingTypeSelect}
                                                deviceTemplateDetails={sendalertDetails}
                                                sendalertDetails={sendalertDetails}
                                                emptyField={emptyField && sendalertDetails.recepient_details.length === 0}
                                            />
                                        </div>
                                        <div className="mb-[32px]">
                                            <p className="text-[12px] leading-[16px] font-semibold text-[#000000] pb-[10px]">Alert Priority</p>
                                            <div className='w-full'>
                                                <div className='flex items-center pt-[7px]'>
                                                    <>
                                                        <div className="relative flex items-center">
                                                            <button
                                                                id={'high'}
                                                                onClick={() => handleOnChangeUserDetails("alert_priority", 'High')}
                                                                type='button' className={`w-[157px] ${sendalertDetails.alert_priority === 'High' ? 'bg-[#EDD7E1]' : 'bg-white'} py-2 border hover:bg-[#EDD7E1] border-[#972E4C] h-fit rounded-[16px] flex items-center justify-center`}>
                                                                <span className='text-lg font-semibold text-center text-[#972E4C]' data-testid="high-btn" id="high">High</span>
                                                            </button>
                                                        </div>
                                                        <div className="relative ml-[16px] flex items-center">
                                                            <button
                                                                onClick={() => handleOnChangeUserDetails("alert_priority", 'Medium')}
                                                                type='button' className={`w-[157px] ${sendalertDetails.alert_priority === 'Medium' ? 'bg-[#EDD7E1]' : 'bg-white'}  py-2 border hover:bg-[#EDD7E1] border-[#972E4C] h-fit rounded-[16px] flex items-center  justify-center`}>
                                                                <span className=' text-lg text-center font-semibold text-[#972E4C]' data-testid="medium-btn" id="medium">Medium</span>
                                                            </button>
                                                        </div>
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="text-[12px] leading-[16px] font-semibold text-[#000000] pb-[12px]">Alert Message</p>
                                        <TextAreaWellness
                                            PatientNotes={false}
                                            dataTestid={'alert_message'}
                                            htmlFor={'alert_message'}
                                            id={'alert_message'}
                                            value={sendalertDetails?.alert_message}
                                            placeholder={'Type message here...'}
                                            emptyField={emptyField && sendalertDetails?.alert_message === "" && sendalertDetails?.alert_message === undefined}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            handleOnCLickActivate={''}
                                        />
                                    </div>
                                    <div className='px-2.5 flex justify-end pt-3'>
                                        <button
                                            loading={loading}
                                            disabled={sendalertDetails?.alert_message === "" || sendalertDetails?.alert_message.trim() === "" || sendalertDetails.recepient_details.length === 0 || sendalertDetails.alert_priority === ""}
                                            id={'send'}
                                            onClick={handleSendButton}
                                            className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px]
                                                    bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>Send</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    }
                />
            }
            {/* send alet confirmation state */}
            {confirmationState && (
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleSendAlert}
                            handleClose={() => { setConfirmationState(false) }}
                            tittle={'Send Alert Message'}
                            message={'Are you sure you want to send alert message?'}
                            buttonName={"Yes"}
                            CancelButton={'No'}
                            loadingActivation={sendalertloading}
                            disabled={sendalertloading}

                        />
                    }
                />
            )}
            {/* table deatilsssssss */}
            {confirmationTablestate &&
                <AnimatedModel key="edit-model"
                    Children={
                        <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabIndex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{ display: "block" }}>
                            <div ref={outsideClickRef} data-te-modal-dialog-ref="" className="pointer-events-none relative flex min-h-[calc(100vh-1rem)] w-auto translate-y-[-50px] translate-x-[10px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[943px] m-auto max-w-[943px] pt-[80px]">
                                <div className="pointer-events-auto flex w-full flex-col rounded-[16px] border-none bg-white bg-clip-padding text-current shadow-lg outline-none min-w-[943px] mx-auto max-w-[943px] px-[24px]  pb-5 relative">
                                    <img
                                        onClick={() => {
                                            setConfirmationTableState(false);
                                            setEmptyField(false);
                                            setsendalertDetails(prevState => ({
                                                ...prevState,
                                                alert_priority: '',
                                                alert_message: '',
                                                recepient_details: []// Clear alert_priority while keeping other fields intact
                                            }));
                                        }} src='/images/close_icon.svg' className='cursor-pointer absolute top-[30px] right-[27px]' />
                                    <div className="h-[500px] overflow-auto scrollbar_gray">
                                        <div>
                                            {providerList.data.some((Provider) => {
                                                const userId = Provider?.providerUserData?.user_id;
                                                const emailaddress = Provider?.providerUserData?.preference_mode==='email'
                                                ;
                                                const isUserIdIncluded = sendalertDetails?.recepient_details.includes(userId) && emailaddress;
                                                return isUserIdIncluded;
                                            }) && (
                                            <>
                                                <div className="flex mt-[24px] justify-between pb-[11px]">
                                                    <h1 className='text-2xl font-normal text-[#000]'>Email Sent</h1>
                                                </div>
                                                <h1 className="text-[16px] leading-[21px] pb-[7px] text-[#000000] font-semibold">Email has been sent to the following providers:</h1>
                                            </>
                                                )}

                                            {providerList.data.map((Provider, index) => {
                                                const userId = Provider?.providerUserData?.user_id;
                                                const emailaddress = Provider?.providerUserData?.preference_mode==='email';
                                                const isUserIdIncluded = sendalertDetails?.recepient_details.includes(userId) && emailaddress;
                                                if (isUserIdIncluded) {
                                                    return (
                                                        <><div className="max-h-[300px] overflow-auto scrollbar_gray" key={index}>
                                                            <p className="text-[16px] leading-normal font-normal text-[#000000]">
                                                                {Provider?.providerUserData?.email_address} ({Provider?.providerUserData?.last_name}, {Provider?.providerUserData?.first_name})
                                                            </p>
                                                        </div></>
                                                    );
                                                }
                                                return null; // Return null for rows that don't match the condition
                                            })}
                                        </div>
                                        {/* contains only mobile number */}
                                        <div>
                                            {providerList.data.some((Provider) => {
                                                const userId = Provider?.providerUserData?.user_id;
                                                const mobilenumber = Provider?.providerUserData?.preference_mode==='call';
                                                const isUserIdIncluded = sendalertDetails?.recepient_details.includes(userId) && mobilenumber;
                                                return isUserIdIncluded;
                                            }) && (
                                            <>
                                                <div className="flex mt-[24px] justify-between pb-[11px]">
                                                    <h1 className='text-2xl font-normal text-[#000]'>Please Call</h1>
                                                </div>
                                                <h1 className="text-[16px] leading-[21px] text-[#000000] font-semibold">Please call the following providers:</h1>
                                            </>
                                                )}
                                            <>
                                                {providerList.data.some((Provider) => {
                                                    const userId = Provider?.providerUserData?.user_id;
                                                    const mobilenumber = Provider?.providerUserData?.preference_mode==='call';
                                                    const isUserIdIncluded = sendalertDetails?.recepient_details.includes(userId) && mobilenumber;
                                                    return isUserIdIncluded;
                                                }) && (
                                                <div class='border border-[#EDD7E1] mt-4 mb-4 mr-2 rounded pb-2'>
                                                    <table id="organization_table" aria-label="Outside Table" class="w-full table-fixed">
                                                        <thead>
                                                            <tr class="h-[38px] w-full bg-[#EDD7E1] rounded-sm">
                                                                <th class="px-[18px] py-2 rounded-tl-sm rounded-bl-sm">
                                                                    <span class="flex items-center justify-start text-sm font-normal text-[#000000]">Provider ID</span>
                                                                </th>
                                                                <th id="id" class="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                                                    <span class="flex items-center justify-start text-sm font-normal text-[#000000]">Provider Name</span>
                                                                </th>
                                                                <th id="id" class="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                                                    <span class="flex items-center justify-start text-sm font-normal text-[#000000]">Main Number</span>
                                                                </th>
                                                                <th id="id" class="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                                                    <span class="flex items-center justify-start text-sm font-normal text-[#000000]">Mobile Number</span>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {providerList.data.map((Provider, index) => {
                                                                        const userId = Provider?.providerUserData?.user_id;
                                                                        const mobilenumber = Provider?.providerUserData?.preference_mode==='call';
                                                                        const isUserIdIncluded = sendalertDetails?.recepient_details.includes(userId) && mobilenumber;
                                                                        if (isUserIdIncluded) {
                                                                            return (
                                                                                <tr key={index}>
                                                                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                                                        {Provider?.providerUserData?.user_id}
                                                                                    </td>
                                                                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                                                        {Provider?.providerUserData?.last_name}, {Provider?.providerUserData?.first_name}
                                                                                    </td>
                                                                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                                                        {Provider?.providerUserData?.main_no_country_code} {formatMobileNumber(Provider?.providerUserData?.main_number)}
                                                                                    </td>
                                                                                    <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                                                        {Provider?.providerUserData?.mob_no_country_code} {formatMobileNumber(Provider?.providerUserData?.mobile_number)}
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                        return null; // Return null for rows that don't match the condition
                                                                    })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                    )}
                                            </>
                                        </div>
                                    </div>
                                    <div className='px-2.5 flex justify-end pt-3'>
                                        <button
                                            loading={loading}
                                            id={'continue'}
                                            onClick={handleContinueButton}
                                            className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px]
                                                    bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>Continue</button>
                                    </div>
                                </div>
                                {
                                    toastErrorMessage !== '' && <Toast
                                        message={toastErrorMessage}
                                        type='error'
                                        setToastmessage={setToastErrorMessage}
                                        modal={true}
                                    />
                                }
                            </div>
                        </div>
                    }
                />
            }
            {
                toastErrorMessage !== '' && <Toast
                    message={toastErrorMessage}
                    type='error'
                    setToastmessage={setToastErrorMessage}
                    modal={true}
                />
            }
        </>
    )
}